// Write your code here
import {Link} from 'react-router-dom'
import CartContext from '../../context/CartContext'
import './index.css'

const CartSummary = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList} = value
      const totalItems = cartList.length
      const totalAmount = cartList.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0,
      )
      return (
        <div className="summary-card">
          <div className="price-card">
            <p className="total">Order Total: </p>
            <h1 className="totalAmount">₹{totalAmount}/-</h1>
          </div>
          <p className="amount">{totalItems} items in cart</p>
          <Link to="/checkout">
            <button type="button" className="checkout">
              checkout
            </button>
          </Link>
        </div>
      )
    }}
  </CartContext.Consumer>
)
export default CartSummary
